export const formatCardNumber = (value) => {
  const number = value?.replace(/\s/g, "");
  if (number) {
    return `••••\u00A0${number.slice(number.length - 4)}`;
  }
  return value;
};
